import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IMeasurementLinkData } from "common/records/MeasurementLink";

export const RECEIVE_MEASUREMENT_LINK = "@measurementLinks/RECEIVE_MEASUREMENT_LINK";
export const RECEIVE_MEASUREMENT_LINKS = "@measurementLinks/RECEIVE_MEASUREMENT_LINKS";
export const RESET_MEASUREMENT_LINK = "@measurementLinks/RESET_MEASUREMENT_LINK";

export const MeasurementLinkActions = {
  receiveMeasurementLink: (measurementLink: IMeasurementLinkData) =>
    createAction(RECEIVE_MEASUREMENT_LINK, { measurementLink }),
  receiveMeasurementLinks: (measurementLinks: IMeasurementLinkData[]) =>
    createAction(RECEIVE_MEASUREMENT_LINKS, { measurementLinks }),
  resetMeasurementLink: (measurementLinkId: number) => createAction(RESET_MEASUREMENT_LINK, { measurementLinkId }),
};

export type MeasurementLinkActions = ActionsUnion<typeof MeasurementLinkActions>;
